var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"adwords_index\"\u003E\u003CAdwordsTable :data=\"data\" :meta=\"meta\" @load-data=\"loadData\"\u003E\u003C\u002FAdwordsTable\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;